(function ($) {
  'use strict';

  window.ys.lv2023 = new LaVuelta2023();

  /**
   * Initialize the quiz
   */
  if ($('body').hasClass('lv_2023')) {
    window.ys.lv2023Contest = new LaVuelta2023.Contest();
  }
}).bind(window)(jQuery);
